import { applicationCapabilitiesStore } from "../ApplicationCapabilitiesStore";
import { getResolvedCapability } from "../capabilityLookup";
import {} from "../types/ClientResolvedCapability";
import {} from "@next-platform/packages-ts-types/application/types/capabilities";
import { useCallback, useRef } from "react";
import { useSyncExternalStore } from "use-sync-external-store/shim";
const emptyApplicationCapabilityRecord = {};
const getNullServerSnapshot = () => null;
const getArrayServerSnapshot = () => emptyApplicationCapabilityRecord;
export function useApplicationCapabilities(keyOrKeys) {
    const isArrayInput = Array.isArray(keyOrKeys);
    const refKeys = useRef(isArrayInput ? keyOrKeys : []);
    const refPreviousResult = useRef({});
    const keysString = JSON.stringify(isArrayInput ? keyOrKeys : []);
    const refPrevKeysString = useRef(keysString);
    if (refPrevKeysString.current !== keysString) {
        refKeys.current = isArrayInput ? keyOrKeys : [];
        refPreviousResult.current = {};
        refPrevKeysString.current = keysString;
    }
    const getSingleSnapshot = useCallback(() => getResolvedCapability(keyOrKeys), [keyOrKeys]);
    const getArraySnapshot = useCallback(() => {
        const nextResult = refKeys.current.reduce((accumulator, key) => {
            accumulator[key] = getResolvedCapability(key);
            return accumulator;
        }, {});
        const previousResult = refPreviousResult.current;
        const previousKeys = Object.keys(previousResult);
        const nextKeys = Object.keys(nextResult);
        if (previousKeys.length === nextKeys.length && previousKeys.every((key) => previousResult[key] === nextResult[key])) {
            return previousResult;
        }
        refPreviousResult.current = nextResult;
        return nextResult;
    }, []);
    const getSnapshot = isArrayInput ? getArraySnapshot : getSingleSnapshot;
    const snapshot = useSyncExternalStore(applicationCapabilitiesStore.subscribe, getSnapshot, isArrayInput ? getArrayServerSnapshot : getNullServerSnapshot);
    return snapshot;
}
